module.exports = __webpack_public_path__ + "img/pyq.1766306608134.png";